import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export const ForcePasswordChange = () => {
  const { user, refreshMe, logout } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8) return toast.error("New password must be at least 8 characters");
    if (f.next !== f.confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password updated");
      await refreshMe();
      navigate("/dashboard", { replace: true });
    } catch (err) { toast.error(apiErr(err)); } finally { setBusy(false); }
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4" data-testid="force-password-change">
      <form onSubmit={submit} className="w-full max-w-sm space-y-3 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <KeyRound className="h-6 w-6 text-emerald-600" />
        <h1 className="text-xl font-semibold text-slate-900">Set your own password</h1>
        <p className="text-sm text-slate-500">Hi {user?.name}, you signed in with a temporary password. Choose a new password to continue.</p>
        <Input type="password" placeholder="Temporary password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} data-testid="fpc-current" />
        <Input type="password" placeholder="New password (min 8 characters)" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} data-testid="fpc-new" />
        <Input type="password" placeholder="Confirm new password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="fpc-confirm" />
        <Button type="submit" disabled={busy} className="w-full bg-slate-900 text-white" data-testid="fpc-submit">Update password</Button>
        <button type="button" onClick={logout} className="w-full text-xs text-slate-500 hover:underline" data-testid="fpc-logout">Log out</button>
      </form>
    </div>
  );
};
